module.exports = __webpack_public_path__ + "static/media/Scene 7.1.5f8ed291.jpg";